import { useCallback, useEffect, useState } from 'react'
import { attempt } from 'lodash'

const useTabFocus = (handleOnFocus, handleOnBlur) => {
  const [isTabFocused, setIsTabFocused] = useState(false)

  const onFocus = useCallback(() => {
    setIsTabFocused(true)
    attempt(handleOnFocus)
  }, [handleOnFocus])

  const onBlur = useCallback(() => {
    setIsTabFocused(false)
    attempt(handleOnBlur)
  }, [handleOnBlur])

  useEffect(() => {
    window.addEventListener('focus', onFocus)
    window.addEventListener('blur', onBlur)

    onFocus()

    return () => {
      window.removeEventListener('focus', onFocus)
      window.removeEventListener('blur', onBlur)
    }
  }, [onBlur, onFocus])

  return isTabFocused
}

export default useTabFocus
